// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"042bb37f","239":"dfdb0d71","455":"2c5d621b","488":"7213179a"}[chunkId] + ".chunk.js";
};